import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import StatisticsTable from './StatisticsTable.js';
import {
    mainSelector,
    getHeaderName,
    getMetrics,
    getKeysMetric,
    getRowsCount
} from './StatisticsTable.selectors';

const mapStateToPropsSelectors = createStructuredSelector({
    data: mainSelector,
    headerName: getHeaderName,
    metrics: getMetrics,
    keysMetric: getKeysMetric,
    rowsCount: getRowsCount
});

const StatisticsTableComponent = connect(
    function mapStateToProps(state) {
        return {
            ...mapStateToPropsSelectors(state),
            loading: state.statistics.data.loading
        };
    },
    function mapDispatchToProps(dispatch) {
        return {
        };
    }
)(StatisticsTable);

export default StatisticsTableComponent;
